import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';
import cn from '../../../utils/tools/cn';

// Components
import BackButton from '../../atoms/BackButton/BackButton';

import styles from './TabsBar.module.scss';

function TabsBar({
  items, handleScrollToSection, activeTab,
}) {
  const { t } = useTranslation();
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div className={styles.bar}>
      {!isMobile ? <BackButton /> : null}

      <ul className="m-t-30 mobile-m-t-0">
        {items?.map((item, index) => (
          <li key={index}>
            <button
              type="button"
              onClick={() => handleScrollToSection(index)}
              className={cn([
                'm-b-20 mobile-m-b-10 w-100 text-left fs-16 fw-500 c-pointer',
                styles.menu_item,
                index === activeTab ? styles.active : '',
              ])}
            >
              {t(item.label)}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}

TabsBar.propTypes = {
  items: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})])).isRequired,
  handleScrollToSection: PropTypes.func,
  activeTab: PropTypes.number,
};

TabsBar.defaultProps = {
  handleScrollToSection: () => {},
  activeTab: 0,
};

export default TabsBar;
